/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import iconSprite from '../../../assets/icon-sprite.svg';
import sampleLoan from '../../../assets/sample_loans.csv';
import AxiosClient from '../../utils/AxiosClient';

class CreateLoanMultiple extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleOnSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    const { file, require_guarantor } = this.state;
    const { onClose } = this.props;
    formData.append('file', file, file.name);
    formData.append('require_guarantor', require_guarantor);
    this.setState({ loading: 'Uploading File...' }, async () => {
      try {
        const client = await AxiosClient();
        const response = (await client.post('/business/loans/upload', formData))?.data;
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message);
        onClose?.();
      } catch (error) {
        this.setState({ loading: false },
          () => toast.error(error.response?.data?.message || error.response?.statusText
            || error.message
            || 'Seems like something went wrong with your request. Please try again.'));
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    const { visible, onClose = function $() { } } = this.props;
    const { file, require_guarantor, loading } = this.state;
    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="multipleCustomersLabel">Bulk Loans</h5>
            <button type="button" className="close" onClick={onClose}>
              <svg width="48" height="48">
                <use xlinkHref={iconSprite + '#close-icon'}></use>
              </svg>
            </button>
          </div>
          <div className="modal-body">
            <form
              action=""
              className="modal-form"
              onDrop={(e) => {
                e.preventDefault();
                if (e.dataTransfer.items && e.dataTransfer.items[0].kind === 'file') {
                  const file = e.dataTransfer.items[0].getAsFile();
                  this.setState({ file });
                } else {
                  const file = e.dataTransfer.files[0];
                  this.setState({ file });
                }
              }}
              onDragOver={(e) => e.preventDefault()}
              onSubmit={this.handleOnSubmit}>
              <div className="form-group upload-btn">
                <input
                  type="file"
                  className="form-control-file"
                  id="uploadDocument"
                  ref={(fileInput) => {
                    this.fileInput = fileInput;
                  }}
                  onChange={(e) => {
                    this.setState({ file: e.target.files?.[0] });
                  }}
                  accept="text/csv, application/vnd.ms-excel" />
                <div className="label" htmlFor="uploadDocument" hidden={!!file}>
                  <div className="icon-upload">
                    <svg width="48" height="48">
                      <use xlinkHref={iconSprite + '#image'}></use>
                    </svg>
                  </div>
                  <div className="upload-text">
                    <div className="top">
                      <h3>
                        Drag and drop your file
                      </h3>
                      <p>
                        or
                        {' '}
                        <Link to="#" onClick={() => this.fileInput.click()}>browse</Link>
                        {' '}
                        to choose.
                      </p>
                    </div>
                    <div className="down">
                      <p>
                        (file should be at most 4MB in size.)
                      </p>
                    </div>
                  </div>
                </div>
                <div className="successUpload" hidden={!file}>
                  <div className="btn-wrapper">
                    <button
                      type="button"
                      className="btn btn-link text-danger"
                      onClick={() => {
                        this.fileInput.value = null;
                        this.setState({ file: null });
                      }}>
                      Remove
                    </button>
                  </div>
                  <div className="file">
                    <div className="file--wrapper">
                      <div className="file-icon">
                        <svg width="32" height="32">
                          <use xlinkHref={iconSprite + '#file'}></use>
                        </svg>
                      </div>
                      <div>
                        <p className="name">{file?.name}</p>
                        <p className="size">
                          {file?.size}
                          b
                        </p>
                        <p className="type">
                          {file?.type}
                        </p>
                      </div>
                    </div>
                    <div className="file-status">
                      <svg width="24" height="24">
                        <use xlinkHref={iconSprite + '#done'}></use>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="require_guarantor" className="form-label">Do you want a guarantor for the uploaded loans?</label>
                <div className="Row">
                  <div className="col-md-6">
                    <label className="card-check card-check__radio">
                      <input
                        className="card-check__option"
                        type="radio"
                        name="require_guarantor"
                        value=""
                        onChange={() => this.setState({ require_guarantor: true })} />
                      <div className="card-check__value">
                        <span className="card-check__checkmark"></span>
                        <p className="card-check__value-text">Yes</p>
                      </div>
                    </label>
                  </div>
                  <div className="col-md-6">
                    <label className="card-check card-check__radio">
                      <input
                        className="card-check__option"
                        type="radio"
                        name="require_guarantor"
                        value="0"
                        onChange={() => this.setState({ require_guarantor: false })} />
                      <div className="card-check__value">
                        <span className="card-check__checkmark"></span>
                        <p className="card-check__value-text">No</p>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <div className="tips">
                <p>
                  **File should be a CSV.
                </p>
                <p className="modal-body__p">
                  The list columns should be
                  {' '}
                  <span style={{ fontWeight: 'bold' }}>Email, Phone Number, Duration, Interest Rate, Loan Amount </span>
                  respectively.
                </p>
                <p style={{ marginTop: '-30' }}>
                  <Link to={sampleLoan} target="_blank" download>Sample Loans CSV Format</Link>
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={!!loading || typeof require_guarantor !== 'boolean' || !['text/csv', 'application/vnd.ms-excel'].includes(file?.type)}>
                  {loading || 'Upload Loans'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    );
  }
}

export default CreateLoanMultiple;
